<template>
	<div class="stu_wrap" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
		<div class="stu_cont">
			<div class="head_tite">
				<div class="left">
					<span style="border-left: 6px solid #5397f7;">{{titleCourse}}</span>
				</div>
				<div class="right">
					<el-button type="primary" @click="intoClass()">加入班级</el-button>
				</div>
			</div>
			<div class="course_list" v-if="courseList.length">
				<li class="course-item" v-for="(item,index) in courseList" :key="index">
					<div class="course_left">
						<img :src="item.courseLogo?item.courseLogo:courseDefPic"/>
					</div>
					<div class="course_right">
						<h3>{{item.courseName}}</h3>
						<div class="icons">
							<div class="teachName icons-item">
								<img src="../../../../static/images/course/teachClassIcon/teacher.png"/>
								<span :title="item.teacherName">教师：{{item.teacherName}}</span>
							</div>
							<div class="hour icons-item">
								<img src="../../../../static/images/course/teachClassIcon/classHour.png"/>
								<span :title="item.courseHour">课时：{{item.courseHour}}</span>
							</div>
							<div class="className icons-item">
								<img src="../../../../static/images/course/teachClassIcon/class-sm.png"/>
								<span :title="item.className">班级：{{item.className}}</span>
							</div>
							<div class="progress icons-item" v-if="productFlag != 4">
								<img src="../../../../static/images/course/teachClassIcon/task-sm.png"/>
								<span>学习进度：</span>
								<el-progress :percentage="Math.ceil(item.progress)" :stroke-width="12"></el-progress>
							</div>
						</div>
						<p class="course_brief">课程简介：{{item.courseContext}}</p>
						<el-button type="primary" @click="startSudy(item)">开始学习</el-button>
					</div>
				</li>
			</div>
			<div class="noLists" v-else>
				<img src="../../../../static/images/common/noorder_pic.png"/>
				<p>暂无课程</p>
			</div>
			<pagination
				class="pageStyle"
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
        v-if="pageTotal.total>10"
      ></pagination>
		</div>
		<!--加入班级-->
		<el-drawer
		  title="加入班级"
		  :visible.sync="drawer"
		  :direction="direction"
		  :close-on-press-escape="false"
		  :wrapperClosable="false"
		  :with-header="false">
		  <div class="drawer_content">
		  	<header>
		  		<span>加入班级</span><img @click="close()" src="../../../../static/images/close.png"/>
		  	</header>
		  	<div class="ipt">
		  		<p>班课邀请码：</p>
		  		<el-input class="ipt_name" v-model="invitCode" placeholder="请输入邀请码"></el-input>
		  	</div>
		  	<div class="btn">
		  		<el-button @click="close()">取消</el-button>
					<el-button type="primary" @click="save()">保存</el-button>
		  	</div>
		  </div>
		</el-drawer>
	</div>
</template>

<script>
	import Pagination from "../../paginator/paginator.vue";
	import * as api from "../../../api/individualApi";
	export default {
		components:{
	    Pagination
	  },
		data(){
			return {
				courseList: [],
				courseDefPic:'/static/images/newCourse/courseCover/cover1.png',
				invitCode:'',
				drawer: false,
				direction: 'rtl',
				productFlag: sessionStorage.getItem('productFlag'),
				titleCourse: '',
				loading: true,
				pageTotal: {
	        currentPage: 1,
	        pageSize: 10,
	        total: 0
	      }
			}
		},
		created(){
			this.getIndividualStuList();
			if(this.productFlag == 2){
				this.titleCourse = '单项训练'
			}else if(this.productFlag == 3){
				this.titleCourse = '综合实训'
			}else if(this.productFlag == 1){
				this.titleCourse = '课证融通'
			}else if(this.productFlag == 4){
				this.titleCourse = '真实任务'
			}
		},
		methods: {
			// 获取课程列表
			getIndividualStuList(){
				let obj = {
					"limit": this.pageTotal.pageSize,
					"page": this.pageTotal.currentPage,
					"courseType":this.productFlag==4?4:3,
					"type":this.productFlag,
					"courseProfessional": sessionStorage.getItem('professional')
				};
				api.getIndividualStuList(obj).then(res=>{
					console.log(res);
					if(res.code == 0){
						this.loading = false;
						this.courseList = res.data.list;
						this.pageTotal.total = res.data.total;
					}else{
						this.$messageError(res.msg);
					}
				})
			},
			handleCurrentChange(val) {
	      this.pageTotal.currentPage = val;
	      this.getIndividualStuList();
	   	},
	   	handleSizeChange(val){
	   		this.pageTotal.pageSize = val;
	   		this.pageTotal.currentPage = 1;
	      this.getIndividualStuList();
	   	},
			// 加入班级
			intoClass(){
				this.invitCode = '';
				this.drawer = true;
			},
			close(){
				this.drawer = false;
			},
			save(){
				if(this.invitCode){
					let obj = {
						"courserType": this.productFlag==4?4:3,
						"invitCode": this.invitCode,
						"type": this.productFlag
					};
					api.intoClass(obj).then(res=>{
						if(res.code == 0){
							this.getIndividualStuList();
							this.$messageSuccess('请等待审核');
							this.drawer = false;
						}else {
							this.$messageError(res.msg);
						}
					})
				}else{
					this.$messageError('邀请码不能为空');
					return;
				}
			},
			// 开始学习
			startSudy(item){
				if(item.status == 1){
					if(item.classStatus == 1){
						console.log(item)
						api.courseAuth(item.courseId).then(res=>{
							if(res.code == 0){
								sessionStorage.setItem('courseType', item.type);
				        sessionStorage.setItem('isPreview', false);
                sessionStorage.setItem('subjectId',item.subjectId)
                sessionStorage.setItem('courseId',item.courseId)
				        let path = '',
                  query = {
                    id: item.courseId,
                    classId: item.classId,
                    className: item.className,
                    classStatus: item.classStatus,
                    courseName: item.courseName,
                    courseType: item.courseType,
                    type: item.type,
                    isPay: item.isPay,
                    courseModel: item.courseModel,
                  }

                if(item.modelType == 1){
                  path = '/learning_module';
                  this.$router.push({ path,query })
                }else{

                  if(this.productFlag==4){
                    path = '/switch/studentTask'
                  }else{
                    path = '/switch/courseware/courseDetail'
                  }
                  const { href } = this.$router.resolve({ path,query });
                  window.open(href, '_blank');
                }

							}else{
								this.$messageWarning(res.msg);
								return;
							}


						})
					}else if(item.classStatus == 2){
	      		this.$messageWarning('课程已结束。。。');
	      		return;
	      	}else if(item.classStatus == 0){
	      		this.$messageWarning('课程未开始。。。');
	      		return;
	      	}
				}else{
					this.$messageWarning('课程更新中，敬请期待...')
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.stu_wrap {
		height: 100%;
		overflow-y: auto;
		.stu_cont {
			padding: 16px;
			.pageStyle {
				width: 86.3%;
				position: fixed;
				bottom: 0;
				background: #fff;
			}
		}
		.top_title {
			position: relative;
			height: 136px;
			margin-bottom: 12px;
			img {
				display: block;
				width: 100%;
				height: 100%;
				border-radius: 4px;
			}
			.pos {
				position: absolute;
				width: 637px;
				height: 66px;
				top: 35px;
				left: 50%;
				margin-left: -318px;
			}
		}
		.head_tite {
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 64px;
			border-bottom: 2px solid #DDE0E2;
			.left {
				display: flex;
				align-items: center;
			}
			.right {
				margin-right: 16px;
				.el-button {
					padding: 9px 27px;
				}
			}
			span {
				display: inline-block;
				height:16px;
        color: #0D141E;
				font-size: 16px;
				margin-left: 32px;
        padding-left: 4px;
			}
		}
		.course_list {
			margin-bottom: 39px;
			.course-item {
				height:143px;
				background:rgba(255,255,255,1);
				box-shadow:0px 0px 10px rgba(0,0,0,0.1);
				border-radius:4px;
				margin-bottom: 16px;
				padding: 24px 22px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.course_left {
					width: 240px;
					height: 136px;
					img {
						display: block;
						width: 100%;
						height: 100%;
						border-radius: 8px;
					}
				}
				.course_right {
					width: calc(100% - 280px);
					h3 {
						font-size: 16px;
						color: #0D141E;
						font-family:Hiragino Sans GB;
						margin-top: -6px;
						margin-bottom: 14px;
					}
					.course_brief {
						font-size: 12px;
						color: #5D646E;
						padding-top: 14px;
						margin-bottom: 14px;
						height: 30px;
						overflow: hidden;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						line-height: 16px;
						word-break: break-all;
					}
					.el-button {
						padding: 8px 44px;
					}
					.icons {
						display: flex;
						justify-content: space-between;
						align-items: center;
						.icons-item {
							display: flex;
							align-items: center;
							margin-right: 40px;
							height: 20px;
							span {
								display: block;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								height: 20px;
								line-height: 20px;
							}
						}
						.hour {
							span {
								width: 96px;
							}
						}
						.className {
							span {
								width: 156px;
							}
						}
						.teachName {
							span {
								width: 140px;
							}
						}
						.progress {
							margin-right: 0;
							/deep/ .el-progress-bar {
								width: 180px;
							}
							/deep/ .el-progress-bar__inner {
								background: #5397F7;
							}
							/deep/ .el-progress__text {
								color: #5397F7;
								font-size: 12px !important;
							}
						}
						img {
							display: inline-block;
							width: 18px;
							height: 18px;
							margin-right: 10px;
						}
						span {
							font-size: 14px;
							color: #0D141E;
						}
					}
				}
			}
		}
		/deep/ .el-drawer {
			width: 480px !important;
		}
		.drawer_content {
			header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 64px;
				border-bottom: 2px solid #DDE0E2;
				padding: 0 20px;
				span {
					font-size: 16px;
					color: #0D141E;
				}
				img {
					display: block;
					width: 26px;
					height: 26px;
					cursor: pointer;
				}
			}
			.ipt {
				padding: 20px 16px;
				p {
					font-size: 12px;
					margin-bottom: 12px;
				}
				/deep/ .ipt_name {
					width: 440px;
					float: left;
					.el-input__inner {
						height: 42px;
						line-height: 42px;
						border: 0;
						background: #F1F2F4;
						border-radius: 4px;
					}
				}
			}
			.btn {
				text-align: center;
				margin-top: 50%;
				.el-button {
					padding: 7px 23px;
					margin-left: 0;
					margin-right: 15px;
				}
			}
		}
		.noLists {
			display: flex;
			flex-direction: column;
			align-items: center;
			img {
				display: inline-block;
				margin-top: 7%;
				width: 250px;
				height: 170px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/TeachClass/indexStudent.vue